<template>
    <div class="bar">
        <div class="container">
            <div class="area-toggles" :class="{ 'whitelabel-editing': editingWhitelabel }">
                <a :href="landlord" class="btn btn-toggle" :class="{ 'active': area !== 'tenants' && !editingWhitelabel }">
                    <i class="icons8-house"/>
                    {{$t('components.space-owner')}}
                </a>
                <a :href="tenant" class="btn btn-toggle" :class="{ 'active': area === 'tenants' }">
                    <i class="icons8-car-2"/>
                    {{$t('components.driver')}}
                </a>
                <a v-if="hasCorporateAccount" :href="corporateRoute" class="btn btn-toggle">
                    <i class="icons8-suitcase-2"/>
                    {{$t('components.fleet-dashboard')}}
                </a>
            </div>

            <a
                v-if="listingPage && listings"
                :href="listingRoute"
                target="_blank"
                class="add-listing btn btn-green"
                @click="logSpaceListingClick"
            >
                <i class="fa-plus fa"/> {{$t('components.list-new-space')}}
            </a>

            <div class="whitelabels" v-if="whitelabels.length > 0 && whitelabels.length <= 3 && area !== 'tenants'">
                <a
                    v-for="(whitelabel, index) in whitelabels"
                    :key="index"
                    :href="editWhitelabel(whitelabel.id)"
                    class="btn btn-toggle"
                    :class="{ 'active': activeWhitelabel === whitelabel.id }"
                >
                    <i class="icons8-bookmark-ribbon"/> {{ whitelabel.subdomain }}
                </a>
            </div>

            <div class="whitelabels toggle" v-if="whitelabels.length > 3 && area !== 'tenants'">
                <a href="#" class="btn btn-toggle" @click.prevent="toggleDropdown">
                    {{$t('components.manage-your-whitelabels')}}
                    <i :class="{
                        'fa-angle-down': !dropdownOpen,
                        'fa-angle-up': dropdownOpen,
                    }" class="fa" />
                </a>
                <whitelabel-dropdown :whitelabels="whitelabels" :open="dropdownOpen" />
            </div>
        </div>
    </div>
</template>

<script>
    import WhitelabelDropdown from './WhitelabelDropdown.vue';
    import { logListASpaceClicked } from '../../modules/mixpanel';
    import { getViewData } from '../../modules/view-data';

    export default {
        name: 'toggle-area',

        components: {
            WhitelabelDropdown,
        },

        props: {
            tenant: {
                type: String,
                default() {
                    return null;
                }
            },

            landlord: {
                type: String,
                default() {
                    return null;
                }
            },

            area: {
                type: String,
                default() {
                    return null;
                }
            },

            whitelabels: {
                type: Array,
                default() {
                    return [];
                }
            },

            activeListings: {
                type: Number,
                default() {
                    return null;
                }
            },

            disabledListings: {
                type: Number,
                default() {
                    return null;
                }
            },

            progressListings: {
                type: Number,
                default() {
                    return null;
                }
            },
        },

        data() {
            return {
                dropdownOpen: false,
            }
        },

        computed: {
            vehicles() {
                return Page.is('accounttenantyour-vehicles');
            },

            listingPage() {
                return Page.is('accountlandlorddashboard');
            },

            listings() {
                return this.activeListings || this.progressListings || this.disabledListings;
            },

            listingRoute() {
                return `${ getViewData('env.LISTING_SUBDOMAIN') }/list-your-space/progress/step-one/location`;
            },

            editingWhitelabel() {
                return Page.is('accountwhitelabeledit');
            },

            activeWhitelabel() {
                  let url = window.location.href;

                  if (url.match(/\d+/)) {
                      return url.match(/\d+/)[0];
                  }

                  return null;
            },

            corporateRoute() {
                return getViewData('env.CORPORATE_SUBDOMAIN');
            },

            hasCorporateAccount() {
                const { corporate_account } = getViewData('user');
                return Boolean(corporate_account && corporate_account.id && corporate_account.is_admin);
            },
        },

        methods: {
            editWhitelabel(id) {
                return this.$laroute.route('account.whitelabel.edit', {instance: id});
            },

            toggleDropdown() {
                if (!this.dropdownOpen) {
                    return this.dropdownOpen = true;
                }

                return this.dropdownOpen = false;
            },

            logSpaceListingClick() {
                logListASpaceClicked();
            },
        },
    }
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import (reference) "~assets/less/variables.less";
    @import (reference) "~bootstrap/less/mixins/grid.less";
    @import (reference) "~bootstrap/less/mixins/clearfix.less";

    .bar {
        padding: 15px 0;
        border-bottom: 1px solid #d3d3d3;
        margin-bottom: 55px;
        font-family: @headings-font-family;
        text-align: center;

        @media (min-width: @screen-sm-min) {
            text-align:left;
        }

        .area-toggles {
            display: inline-block;

            &.whitelabel-editing {
                padding-top: 10px;
            }
        }

        .btn-toggle {
            font-size: 15px;
            font-weight: 600;
            color: #36383e;
            opacity: 0.58;
            padding: 0;
            margin-right: 20px;

            &:nth-of-type(3) {
                margin-right: 0;
            }

            &:hover {
                opacity: 1;
            }

            &:focus {
                border: none;
                box-shadow: none;
            }

            i {
                font-size: 22px;
                vertical-align: middle;
                font-weight: 800;
                padding-right: 3px;
            }

            &.active {
                padding: 5px 12px;
                background-color: #f0f0f0;
                color: #36383e;
                border-radius: 4px;
                box-shadow: none;
                border: none;
                opacity: 1;
            }
        }

        .whitelabels {
            display: inline-block;
            float: right;

            &.toggle {
                padding-top: 7px;

                .btn-toggle {
                    i {
                        vertical-align: top;
                        padding-right: 0;
                        padding-left: 5px;
                    }
                }
            }

            .btn-toggle {
                &:nth-of-type(2) {
                    margin-right: 20px;
                }

                &:last-of-type {
                    margin-right: 0;
                }
            }
        }

        .add-listing {
            color: #ffffff;
            font-size: 12px;
            font-weight: 500;
            font-family: @headings-font-family;
            padding: 10px 15px;
            margin-top: 25px;
            display: block;
            max-width: 150px;
            margin-left: 15px;

            @media (min-width: @screen-sm-min) {
                display: inline-block;
                margin-top: 0;
                float: right;
            }

            i {
                font-size: 16px;
                font-weight: 400;
                vertical-align: text-bottom;
                margin-right: 3px;
            }
        }
    }
</style>
